import React, { useState } from 'react';

import Button from '~/core/atoms/Buttons/Button';
import LoginInput from '~/core/atoms/LoginInput';
import cn from '~/utils/cn.ts';

interface EmailPasswordFormProps {
  isLoading: boolean;
  authError?: string;
  onSubmit: (email: string, password: string) => void;
}

const EmailPasswordForm: React.FC<EmailPasswordFormProps> = ({ isLoading, authError, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validationError, setValidationError] = useState('');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (validationError) setValidationError(''); // Clear validation error on input change
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (validationError) setValidationError(''); // Clear validation error on input change
  };

  const handleSubmit = () => {
    if (!email || !password) {
      setValidationError('Email and password are required');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setValidationError('Please enter a valid email address');
      return;
    }

    setValidationError('');
    onSubmit(email, password);
  };

  // Show validation error first, then auth error
  const errorToShow = validationError || authError;

  return (
    <>
      <div className="mb-16">
        <div className="text-grey-600 mb-8 text-sm font-semibold">Email Address</div>
        <LoginInput loginType="email" name="email" value={email} onChange={handleEmailChange} disabled={isLoading} />
      </div>

      <div className="mb-32">
        <div className="text-grey-600 mb-8 text-sm font-semibold">password</div>
        <LoginInput
          loginType="password"
          name="password"
          value={password}
          onChange={handlePasswordChange}
          disabled={isLoading}
        />
      </div>

      {/* Submit button */}
      <div className="mb-32">
        <Button
          variant="primary"
          size="md"
          onClick={handleSubmit}
          disabled={isLoading}
          className="bg-grey-700 border-grey-700 hover:bg-grey-600 hover:border-grey-600 w-full rounded-full text-white focus:border-pink-700"
        >
          {isLoading ? 'Signing in...' : 'Sign in with Email'}
        </Button>
      </div>

      {/* Error message */}
      <div className={cn('mb-16 h-20 text-center text-sm text-red-700')}>{errorToShow}</div>
    </>
  );
};

export default EmailPasswordForm;
